import { render, staticRenderFns } from "./WonderfulActivities.vue?vue&type=template&id=a7c5cff6&scoped=true"
import script from "./WonderfulActivities.vue?vue&type=script&lang=js"
export * from "./WonderfulActivities.vue?vue&type=script&lang=js"
import style0 from "./WonderfulActivities.vue?vue&type=style&index=0&id=a7c5cff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c5cff6",
  null
  
)

export default component.exports